<template>
    <q-dialog v-model="display" persistent>
        <q-card>
            <q-card-section>
                <div class="text-h6">{{ $t('bank_accounts.edit_form') }}</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <bank-account-edit-form
                    v-model="account"
                    :currency-acronym="currencyAcronym"
                />
            </q-card-section>

            <q-card-actions align="right" class="bg-white text-primary">
                <q-btn flat v-close-popup>{{$t('cancel')}}</q-btn>
                <q-btn color="primary" @click="save" :loading="loading">{{$t('save')}}</q-btn>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import BankAccount from "../models/BankAccount"
import BankAccountEditForm from "./BankAccountEditForm.vue"

export default {
    name: "RecipientBankAccountEditModal",
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        bankAccount: {
            type: Object,
            required: true
        },
        currencyAcronym: {
            type: String,
            required: true
        }
    },
    computed: {
        display: {
            get: function () {
                return this.show
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {
            loading: false,
            account: new BankAccount({
                id: this.bankAccount.id,
                bank_id: this.bankAccount.bank_id,
                payment_method_id: this.bankAccount.payment_method_id,
                number: this.bankAccount.number,
                notes: this.bankAccount.notes
            })
        }
    },
    methods: {
        save() {
            this.loading = true
            this.account.update((data) => {
                this.loading = false
                this.display = false
                this.$emit('updated', data)
            }).catch(error => {
                this.loading = false
                this.$q.notify({
                    message: 'An error has occurred!',
                    color: 'negative'
                })
            })
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {BankAccountEditForm},
}
</script>
<style>

</style>
